import { useRouter } from "next/router";
import { useMemo, useState } from "react";

import type { CardType } from "~/types/card";
import { CollectionCardGroupPreview } from "./CollectionCardGroupPreview";
import { CollectionCardItemPreview } from "./CollectionCardItemPreview";

export const CollectionCardGroup = ({ card }: { card: CardType }) => {
  const { query: routerParams } = useRouter();

  const variants = card.variants.filter(
    (variant) =>
      !routerParams.set ||
      routerParams.set === "*" ||
      variant.setCard.set.code === routerParams.set,
  );

  const [isOpen, setIsOpen] = useState(variants.length === 1);

  const memoisedRender = useMemo(() => {
    return (
      <>
        {isOpen ? (
          <>
            {variants.map((variant) => (
              <CollectionCardItemPreview key={variant.id} card={card} variant={variant} />
            ))}
          </>
        ) : (
          <div className="m-1 duration-500 animate-in fade-in" onClick={() => setIsOpen(true)}>
            <CollectionCardGroupPreview card={card} />
          </div>
        )}
      </>
    );
  }, [card, isOpen, variants]);

  return memoisedRender;
};
